import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const goldIcon = L.divIcon({
  className: "",
  html: '<span class="miral-map-pin"></span>',
  iconSize: [16, 16],
  iconAnchor: [8, 8]
});

export default function LeafletMap({ center, zoom = 12, height = "420px", markers = [] }) {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  return (
    <div
      data-testid="brussels-leaflet-map"
      style={{ height }}
      className="relative w-full rounded-2xl overflow-hidden border border-white/10 z-0"
    >
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={false} dragging={!isMobile} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />
        {markers.map((m, i) => (
          <Marker key={i} position={m.position} icon={goldIcon}>
            <Popup>
              <b>{m.title}</b>
              <br />
              {m.subtitle}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
